import React from 'react';

import time from 'service/time'

import { Table, Button } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";

import { useSelector } from 'react-redux'

import db from 'service/db'

function BoardDetail({ data, root, prev, next }) {
    let userId = useSelector(state => state.userInfo.id);

    const navigate = useNavigate();

    function deleteBoard() {
        if (window.confirm("정말 삭제하겠습니까?")) {
            db.deleteAllDbById(root, data.id).then(item => {
                alert("삭제되었습니다.")
            }).catch(error => {
                alert("문제가 발생했습니다.")
            })
            window.location.assign(`/${root}`)
        }
    }
    function updateBoard() {
        window.location.assign(`/${root}/write/${data.id}`)
    }

    return (
        <div className="m-3">
            <Table bordered responsive="xl" >
                <thead>
                    <tr style={{ verticalAlign: "middle" }}>
                        <th className="text-center" width="10%">제목</th>
                        <th style={{ textAlign: "left" }} width="60%">{data.title}</th>
                        <th className="text-center" width="12%">등록일</th>
                        <th className="text-center" width="18%">{time.parseDate(data.date)}</th>
                    </tr>
                </thead>
                <tbody >
                    <tr style={{ width: "620" }} >
                        <td className="text-left p-3" colSpan="4" height="420vh" >
                            <div id="contents" style={{ textAlign: "left" }}>
                                {data.contents ?
                                    <div dangerouslySetInnerHTML={{ __html: data.contents }} /> :
                                    <div style={{ textAlign: "center" }}> 내용이 없습니다</div>
                                }
                            </div>
                        </td>
                    </tr>
                </tbody>
            </Table>
            <div className="d-flex justify-content-between m-1">
                <div>
                    {userId ?
                        <>
                            <Button className="mx-1" variant="primary" onClick={updateBoard}> 수정</Button>
                            <Button className="mx-1" variant="danger" onClick={deleteBoard}> 삭제</Button>
                        </>
                        :
                        <></>
                    }

                </div>
                <div>
                    {prev.id ? <Button variant="primary" className="mx-1" onClick={() => { navigate(`/${root}/${prev.id * 1}`, { replace: false }); }}>이전글</Button> : <></>}
                    <Button variant="primary" className="mx-1" onClick={() => { navigate(`/${root}`, { replace: false }); }}>목록</Button>
                    {next.id ? <Button variant="primary" className="mx-1" onClick={() => { navigate(`/${root}/${next.id * 1}`, { replace: false }); }}>다음글</Button> : <></>}
                </div>
            </div>
        </div >
    );
}

export default BoardDetail;